import Icons from 'components/Icons'
import './mediaGallery.scss'
import house1 from 'assets/images/house1.jpg'
import { checkImageUrl } from 'utils/modules/Handlers';
import { Config } from "utils";

const MediaGallery = ({ data, onMore, waggle }) => {
    const files = data || [];

    const MediaType = ({ media, more }) => {
        const index = media.lastIndexOf('.');
        const type = media.slice(index + 1).toLowerCase();

        if (['mp4', 'webm', 'ogg', 'mov'].includes(type)) {
            return (
                <video width="320" controls src={`${Config.SERVER_URL}${media}`}>
                    Your browser does not support the video tag. Please try a different browser or format.
                </video>
            );
        } else {
            return (<img src={checkImageUrl(media, house1)} alt="" className={`${more && 'grayscale'}`} />);
        }
    }

    return (
        <div className={`media-gallery-container ${waggle && 'waggle'}`}>
            {
                waggle
                    ? <div className="gallery">
                        <div className="horizontal">
                            {
                                files.slice(0, 3).map((file, index) => (
                                    <MediaType key={index} media={file} />
                                )) || <img src={house1} alt="" />
                            }
                        </div>
                    </div>
                    : <>
                        {
                            files.length >= 3
                                ? <div className="gallery mix">
                                    <div className="vertical more">
                                        <MediaType media={files[0]} />
                                    </div>
                                    <div className="horizontal">
                                        <MediaType media={files[1]} />
                                        {
                                            files.length > 3
                                                ? <>
                                                    {
                                                        onMore ?
                                                            <div className='more-media' onClick={onMore}>
                                                                <Icons.Eye width={16} height={16} />
                                                                <p>View More</p>
                                                            </div> :
                                                            <div className='more-count'>+{files.length - 3}</div>
                                                    }
                                                    <MediaType media={files[2]} more />
                                                </>
                                                : <MediaType media={files[2]} />
                                        }
                                    </div>
                                </div>
                                : files.length === 2
                                    ? <div className="gallery">
                                        <div className="horizontal">
                                            <MediaType media={files[0]} />
                                        </div>
                                        <div className="horizontal">
                                            <MediaType media={files[1]} />
                                        </div>
                                    </div>
                                    : <div className="gallery">
                                        <div className="horizontal">
                                            {
                                                files[0]
                                                    ? <MediaType media={files[0]} />
                                                    : <img src={house1} alt="" />
                                            }
                                        </div>
                                    </div>
                        }
                    </>
            }
        </div>
    )
}


export default MediaGallery;